import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import DialogModal from './DialogModal';
import { DialogTitle } from 'material-ui/Dialog';
import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';
import Button from '../Parts/Button';
import { ADDRESS_NAME_PREVIEW_LIMIT } from '../../constants/Constants';

const styles = () => ({
  text: {
    marginBottom: "40px",
    textAlign: "left",
  },

  gutters: {
    background: "#FFFFFF",
    fontSize: "15px",
    fontWeight: 700,
    boxShadow: '0px 1px 0px #00000029',
    width: '100%',
    boxSizing: 'border-box',
    position: 'sticky',
    top: 0,
    zIndex: 1,
    padding: '0'
  },

  textTitle: {
    marginBottom: "40px",
    textAlign: "left",
    fontWeight: 700
  },

  button: {
    background: "#F03A47",
    "&:hover::before": {
      backgroundColor: "#F03A47",
      opacity: 0.6,
    },
  },

  contentContainer: {
    margin: 0,
    padding: 0,
    textAlign: "left"
  },

  paper: {
    maxHeight: 'unset',
    background: "#F4F6F9",
    width: '400px',
  },

  sectionContainers: {
    width: '100%',
    boxSizing: 'border-box',
  },

  sectionContainer: {
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    alignContent: 'flex-start',
    padding: "0 25px",
  },

  sectionTitle: {
    paddingTop: '25px',
    fontSize: "13px",
    fontWeight: 700,
  },

  sectionDesc: {
    fontSize: "12px",
  },

  sectionContent: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: '20px',
  },

  buttonContainer: {
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '25px',
    justifyContent: 'center',
  }
});

class ConfirmSendDialog extends React.Component {
  handleClick = () => {
    this.props.action();
  };

  renderAddressNames = (names) => {
    if (names.length > ADDRESS_NAME_PREVIEW_LIMIT) {
      return names.splice(0, ADDRESS_NAME_PREVIEW_LIMIT).join("様, ") + "様...他";
    } else {
      return names.join("様, ") + "様";
    }
  };

  render() {
    const { classes, toggleDialog, isOpen, hasLetterOrderHistoryNames, duplicateNames } = this.props;

    return (
      <DialogModal
        open={isOpen}
        onClose={toggleDialog}
        aria-labelledby="pop-up-window"
        maxWidth={false}
        classes={{
          paper: classes.paper,
          contentContainer: classes.contentContainer
        }}
      >

        <Toolbar classes={{ gutters: classes.gutters }}>
          <DialogTitle disableTypography>
            注文の宛先をご確認ください。
          </DialogTitle>
        </Toolbar>

        <div className={classes.sectionContainers}>
          {(hasLetterOrderHistoryNames.length) > 0 && (
            <div className={classes.sectionContainer}>
              <div className={classes.sectionTitle}>1週間以内に注文済みの宛先が含まれています。</div>
              <div className={classes.sectionContent}>
                <Typography variant="subheading" className={classes.sectionDesc}>
                  あなたかチームの誰かが1週間以内の注文で既に手紙を送付しています。
                </Typography>
                <Typography variant="subheading" className={classes.sectionDesc} style={{ marginTop: "10px" }}>
                  宛先：{this.renderAddressNames(hasLetterOrderHistoryNames)}
                </Typography>
              </div>
            </div>
          )}
          {(duplicateNames.length) > 0 && (
            <div className={classes.sectionContainer}>
              <div className={classes.sectionTitle}>同姓同名の宛先が含まれています。</div>
              <div className={classes.sectionContent}>
                <Typography variant="subheading" className={classes.sectionDesc}>
                  キーマンによっては複数の会社に所属しており、同じキーマンにレターが複数送信される可能性があります。
                </Typography>
                <Typography variant="subheading" className={classes.sectionDesc} style={{ marginTop: "10px" }}>
                  宛先：{this.renderAddressNames(duplicateNames)}
                </Typography>
              </div>
            </div>
          )}
        </div>

        <div className={classes.buttonContainer}>
          <Button
            handleClickButton={toggleDialog}
            text="キャンセル"
            type="ghost"
          ></Button>
          <Button
            handleClickButton={this.handleClick}
            text='注文を続行'
            style={{ marginLeft: "30px" }}
          ></Button>
        </div>
      </DialogModal>
    );
  }
}

ConfirmSendDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  duplicateNames: PropTypes.array,
  hasLetterOrderHistoryNames: PropTypes.array,
  action: PropTypes.func.isRequired,
};

export default withStyles(styles)(ConfirmSendDialog);



// WEBPACK FOOTER //
// ./src/components/common/ConfirmSendDialog.jsx